import React from "react";
import { Card, CardBody, Row, Col, Badge, Button } from "reactstrap";
import avatarDefault from "assets/images/users/avatar-1.jpg";

const EmployeeHeaderCard = ({ employee, attendance, onNewOrderClick, onRequestEditClick }) => {
    const getGreeting = () => {
        const hour = new Date().getHours();
        if (hour < 12) return "Good Morning";
        if (hour < 17) return "Good Afternoon";
        return "Good Evening";
    };

    const getAttendanceBadge = (status) => {
        switch (status?.toLowerCase()) {
            case "present":
                return <Badge color="success" className="px-2 py-1"><i className="mdi mdi-check-circle me-1"></i>Present</Badge>;
            case "late":
                return <Badge color="warning" className="px-2 py-1"><i className="mdi mdi-clock-alert me-1"></i>Late In</Badge>;
            case "half day":
                return <Badge color="info" className="px-2 py-1"><i className="mdi mdi-clock-half-full me-1"></i>Half Day</Badge>;
            default:
                return <Badge color="secondary" className="px-2 py-1"><i className="mdi mdi-clock-outline me-1"></i>Not Punched</Badge>;
        }
    };

    return (
        <Card className="overflow-hidden shadow-sm border-0 mb-4" style={{ borderRadius: "12px", background: "linear-gradient(135deg, #ffffff 0%, #f8f9fc 100%)" }}>
            <CardBody className="p-4">
                <Row className="align-items-center">
                    <Col lg={7} md={12}>
                        <div className="d-flex align-items-center">
                            <div className="avatar-md me-3 position-relative">
                                <img
                                    src={employee?.image ? `${process.env.REACT_APP_BASEURL || ''}/${employee.image}` : avatarDefault}
                                    alt="Avatar"
                                    className="img-thumbnail rounded-circle shadow-sm"
                                    style={{ width: "65px", height: "65px", objectFit: "cover" }}
                                    onError={(e) => { e.target.src = avatarDefault; }}
                                />
                                <span className="position-absolute bottom-0 end-0 bg-success border border-white rounded-circle p-1" style={{ width: "12px", height: "12px" }}></span>
                            </div>
                            <div>
                                <h4 className="fw-bold mb-1 text-dark">
                                    {getGreeting()}, {employee?.name || "Team Member"}! 👋
                                </h4>
                                <div className="d-flex flex-wrap align-items-center gap-2 text-muted font-size-13">
                                    <span>
                                        <i className="mdi mdi-badge-account-outline text-primary me-1"></i>
                                        <strong>ID:</strong> {employee?.code || "EMP"}
                                    </span>
                                    <span className="text-secondary">•</span>
                                    <span>
                                        <i className="mdi mdi-briefcase-outline text-primary me-1"></i>
                                        <strong className="text-uppercase">{employee?.role || "Staff"}</strong>
                                    </span>
                                    {employee?.department && (
                                        <>
                                            <span className="text-secondary">•</span>
                                            <span>
                                                <i className="mdi mdi-office-building-outline text-primary me-1"></i>
                                                {employee.department}
                                            </span>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Col>

                    <Col lg={5} md={12} className="mt-3 mt-lg-0">
                        <div className="d-flex flex-column flex-sm-row justify-content-lg-end align-items-sm-center gap-2">
                            {/* Attendance Pill */}
                            <div className="bg-white p-2 px-3 rounded border shadow-sm d-flex align-items-center me-sm-2 mb-2 mb-sm-0">
                                <i className="mdi mdi-fingerprint font-size-24 text-primary me-2"></i>
                                <div>
                                    <div className="d-flex align-items-center gap-2">
                                        <small className="text-muted fw-semibold">Today&apos;s Attendance:</small>
                                        {getAttendanceBadge(attendance?.today?.status)}
                                    </div>
                                    <div className="font-size-12 text-dark mt-1">
                                        <i className="mdi mdi-login text-success me-1"></i>
                                        In: <strong>{attendance?.today?.check_in || "--"}</strong>
                                        <span className="mx-2">|</span>
                                        <i className="mdi mdi-logout text-danger me-1"></i>
                                        Out: <strong>{attendance?.today?.check_out || "--"}</strong>
                                    </div>
                                </div>
                            </div>

                            {/* Quick Action Buttons */}
                            <div className="d-flex gap-2">
                                <Button
                                    color="primary"
                                    className="fw-semibold shadow-sm text-nowrap"
                                    onClick={onNewOrderClick}
                                >
                                    <i className="mdi mdi-plus-circle-outline me-1"></i>
                                    New Order
                                </Button>
                                <Button
                                    color="outline-warning"
                                    className="fw-semibold text-nowrap"
                                    onClick={onRequestEditClick}
                                >
                                    <i className="mdi mdi-lock-alert me-1"></i>
                                    Request Edit
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    );
};

export default EmployeeHeaderCard;
